import React, { Component } from "react";
import Container from '@material-ui/core/Container';
import CssBaseline from '@material-ui/core/CssBaseline';
import Typography from '@material-ui/core/Typography';

import { styles } from '../styles'

export default class NotFound extends Component {
      render() {
        return (
            <Container component="main" maxWidth="xs">
                <div style={styles.paper}>
                <   CssBaseline />
                    <Typography gutterBottom variant="h6" component="h2">
                        404 - Page not found!
                    </Typography>
                </div>
            </Container>
        )
      }
}
